module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/apprenticesPosing-ed4fd2a18932986d429cc02c13295d3c.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/apprenticesPosing.png
// module id = 2369
// module chunks = 2